import { apiService } from '@/shared/services/apiServices';
import serviceRequestEndpoints from './serviceRequestEndpoints';
import type {
  CreateServiceRequestPayload,
  CreateServiceRequestResponse,
  CreateServiceRequestResult,
} from '../types/serviceRequestTypes';

export const createServiceRequest = async (
  payload: CreateServiceRequestPayload
): Promise<CreateServiceRequestResult> => {
  try {
    const result = await apiService.postAPI(
      serviceRequestEndpoints.SERVICE_REQUESTS,
      payload
    );

    if (result.error) {
      const errorData = result.data as { message?: string } | undefined;
      return {
        success: false,
        error:
          errorData?.message ?? 'Nie udało się złożyć zgłoszenia serwisowego.',
      };
    }

    const responseData = result.data as CreateServiceRequestResponse;
    return {
      success: true,
      data: responseData,
      serviceRequestId: responseData?.serviceRequestId,
    };
  } catch {
    return {
      success: false,
      error: 'Nie udało się złożyć zgłoszenia serwisowego.',
    };
  }
};
